import * as yup from 'yup'
import { createTranslationLink } from 'localization/helpers'

// Basic validation
const phoneRegExp = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/g
const phonePrefixRegExp = /^\+[0-9]{2,3}$/
const passwordRegExp = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
const emailRegExp =
	/([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\[[\t -Z^-~]*])/i

export function isPhonePrefixOnly(value: string) {
	return !!value.match(phonePrefixRegExp)
}

export function isValidPhoneNumber(value: string) {
	return !!value.match(phoneRegExp)
}

export function isValidPassword(value: string) {
	return !!value.match(passwordRegExp)
}

export function isValidEmail(value: string) {
	return !!value.match(emailRegExp)
}

export function isNumeric(value: string) {
	return !!value.match(/^[0-9]+$/)
}

// Yup custom methods
yup.addMethod(yup.string, 'phone', function () {
	return this.test('is phone number', createTranslationLink('validation.custom.phone'), function (value = '') {
		return !value || isValidPhoneNumber(value) || isPhonePrefixOnly(value)
	})
})

yup.addMethod(yup.string, 'password', function () {
	return this.test('is password', createTranslationLink('validation.custom.password'), function (value = '') {
		return isValidPassword(value)
	})
})

yup.addMethod(yup.string, 'numeric', function () {
	return this.test('is numeric', createTranslationLink('validation.custom.numeric'), function (value = '') {
		return value.length ? isNumeric(value) : true
	})
})

// Yup create schema function
// By using this instead of using yup directly we make sure that the custom methods are added before any schema is created
// therefore elimitating the concurrency issue during the CI builds
export function createValidationSchema(builder: (yupInstance: typeof yup) => yup.AnySchema) {
	return builder(yup)
}
